import DtoListItemFinance_ParamCurrencySystem from "./DtoListItemFinance_ParamCurrencySystem";
import { EnumSettlementMode, EnumSettlementModeOption } from "./EnumSettlementMode";

/**
 * 
 * @description 自动生成的代码,请勿修改
 */
export default class DtoFormSettlement {
    constructor() {
        //无参构造函数
        this.Visiable = false;
    }

    [proName: string]: any;
    /**
     * 待核销
     */
    NoSettlementPrice?: number;
    /**
     * 剩余
     */
    SurplusPrice?: number;
    /**
     * 账单币制
     */
    BillCurrencySystemId?: string;
    /**
     * 账单币制
     */
    BillCurrencySystemCode?: string;
    /**
     * 账单币制
     */
    BillCurrencySystem?: DtoListItemFinance_ParamCurrencySystem;
    /**
     * 核销主键
     */
    Id?: string;
    /**
     * 本次核销金额
     */
    Price?: number;
    /**
     * 折算金额
     */
    ConvertPrice?: number;
    /**
     * 币制
     */
    CurrencySystemId?: string;
    /**
     * 币制
     */
    CurrencySystem?: DtoListItemFinance_ParamCurrencySystem;
    /**
     * 汇率
     */
    Rate?: number;
    /**
     * 汇率
     */
    DisPlayRate?: number;
    /**
     * 收款方发票抬头
     */
    CollectionTitle?: string;
    /**
     * 付款方发票抬头
     */
    PaymentTitle?: string;
    /**
     * 时间
     */
    SettlementDate?: Date;
    /**
     * 弹出框是否显示
     */
    Visiable?: boolean;
    /**
     * 账单主键
     */
    BillId?: string;
    /**
     * 核销编号
     */
    Code?: string;
    /**
     * 核销方式
     */
    Mode?: EnumSettlementMode;
    /**
     * 备注
     */
    Remark?: string;
    /**
     * 当前时间
     */
    CurrentTime?: Date;
    /**
     * 发票主键
     */
    InvoiceId?: string;
    /**
     * 是否坏账
     */
    IsBad?: boolean;
}

/**
 * -表单校验
 */
export const DtoFormSettlementRules = {
}
